import { render, staticRenderFns } from "./TableViewTab.vue?vue&type=template&id=243a87d0&scoped=true&"
import script from "./TableViewTab.vue?vue&type=script&lang=js&"
export * from "./TableViewTab.vue?vue&type=script&lang=js&"
import style0 from "./TableViewTab.vue?vue&type=style&index=0&id=243a87d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243a87d0",
  null
  
)

export default component.exports